import script from "./StartEndDayButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StartEndDayButton.vue?vue&type=script&setup=true&lang=js"

import "./StartEndDayButton.vue?vue&type=style&index=0&id=779fa5ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779fa5ee"]])

export default __exports__